<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
#app {
 background: #f6f6f6;
}
.w1200{
  width: 1200px;
  margin: 0 auto;
}

</style>
